import { TabPanel } from '@dai/components'
import { Box, Tab, Tabs } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import { useParams } from 'react-router-dom'

import { CommonFilters } from '@/components/filters/filters.helpers'
import StickyHeader from '@/components/StickyHeader'
import { StoreAddressWithQuery } from '@/components/stores/StoreAddressWithQuery'
import { useTabsWithParams } from '@/hooks/use-tabs-with-params'
import useT from '@/i18n/useT'
import { Filter, FilterBar } from '@/pages/components/FilterBar'
import RestockSetupPage from '@/pages/pages/RestockSetupPage'

import RestocksReport from '../restocks/RestocksReport'

export type RestocksTab = 'report' | 'management'

const RestocksTabMap: Record<RestocksTab, number> = {
  report: 0,
  management: 1,
}

const Restocks = () => {
  const { t } = useT()

  const { id: singleStoreId } = useParams<{ id: string }>()

  const filters: Filter[] = [
    {
      label: t('common.other'),
      type: 'preCannedDatePicker',
      options: { startDateKey: 'startDate', endDateKey: 'endDate' },
    },
    {
      label: t('common.startDate'),
      type: 'date',
      options: {
        urlKey: 'startDate',
      },
    },
    {
      label: t('common.endDate'),
      type: 'date',
      options: { urlKey: 'endDate' },
    },
  ]

  const { value, handleChange, sortedTabs } = useTabsWithParams({
    TabMap: RestocksTabMap,
    tabs: [
      {
        key: 'report',
        label: t('restocks.tabs.report'),
        component: <RestocksReport />,
      },
      {
        key: 'management',
        label: t('restocks.tabs.management'),
        component: <RestockSetupPage />,
      },
    ],
  })

  return (
    <>
      <Helmet title={t('restocks.title')} />
      <StickyHeader>
        {singleStoreId && <StoreAddressWithQuery id={singleStoreId} />}
        {value === RestocksTabMap.report && (
          <FilterBar
            filters={
              singleStoreId
                ? filters
                : [...filters, CommonFilters.StoreFilter(t)]
            }
          />
        )}
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {sortedTabs.map(({ label }, index) => (
              <Tab label={label} id={`tab-${index}`} key={`tab-${index}`} />
            ))}
          </Tabs>
        </Box>
      </StickyHeader>
      {sortedTabs.map(({ component }, index) => (
        <TabPanel value={value} index={index} key={`tab-panel-${index}`}>
          {component}
        </TabPanel>
      ))}
    </>
  )
}

export default Restocks
